import axios from 'axios';

const serverOrigin = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:5001';

export const baseApi = `${serverOrigin}/api`;
export const imgUrl = serverOrigin;

export const api = axios.create({
    baseURL: baseApi,
    withCredentials: true,
})